import React from 'react';

interface Props {
  className?: string;
  height?: number;
  width?: number;
  color?: string;
}

export const ChevronLeft = ({
  className = 'chevron-left-icon',
  height = 24,
  width = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    data-testid="chevron-left-icon"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00699 13.427L13.281 17.705C13.675 18.098 14.312 18.098 14.706 17.705C15.098 17.31 15.098 16.671 14.706 16.278L10.431 12L14.706 7.724C15.098 7.328 15.098 6.69 14.706 6.297C14.313 5.901 13.676 5.901 13.281 6.297L9.00699 10.575L8.29599 11.287C7.90199 11.682 7.90199 12.32 8.29599 12.714L9.00699 13.427Z"
      fill={color}
    />
  </svg>
);
